import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck, Eye, LogOut, LayoutDashboard } from "lucide-react";

export function AdminBar() {
  const { user, impersonating, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  if (!(user && user.id)) return null;

  if (impersonating) {
    return (
      <div className="sticky top-0 z-[60] bg-red-600 text-white text-sm font-semibold" data-testid="impersonation-bar">
        <div className="max-w-7xl mx-auto px-4 h-10 flex items-center justify-between gap-3">
          <span className="flex items-center gap-2 min-w-0 truncate"><Eye className="h-4 w-4 shrink-0" /> Şu an <b className="truncate">{user.name}</b> oturumundasınız — Salt Okunur / İzleme Modu</span>
          <button onClick={() => { stopImpersonation(); navigate("/admin"); }} data-testid="impersonation-exit" className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 rounded-lg px-3 py-1"><LogOut className="h-4 w-4" /> İzlemeyi Bitir</button>
        </div>
      </div>
    );
  }

  if (user.role === "admin") {
    return (
      <div className="sticky top-0 z-[60] bg-emerald-600 text-white text-sm font-semibold" data-testid="admin-mode-bar">
        <div className="max-w-7xl mx-auto px-4 h-10 flex items-center justify-between gap-3">
          <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" /> Yönetici Modu Aktif — sayfalarda kalem ikonlarıyla canlı düzenleme yapabilirsiniz</span>
          <button onClick={() => navigate("/admin")} data-testid="admin-bar-panel" className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 rounded-lg px-3 py-1"><LayoutDashboard className="h-4 w-4" /> Panel</button>
        </div>
      </div>
    );
  }
  return null;
}
